import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useDemographicsTableData } from "../../hooks/useDemographicsTableData";
import { usePageFilters } from "../../hooks/usePageFilters";

import DemographicsTable from "./DemographicsTable";

export const IndustryAnalysisDemographicsAgeDistributionTable = () => {
    const t = useTranslation();
    const subtitleFilters = useSubtitleFilters("date");

    const pageFilters = usePageFilters();
    const { data: tableData, isLoading, isError } = useDemographicsTableData();

    return (
        <WidgetContainer
            minWidth="100%"
            isLoading={isLoading}
            loaderHeight={300}
            loaderWidth="100%"
            subtitleFilters={subtitleFilters}
            noData={isError ? !isLoading : null}
            title={t("category.demographics.age.chart.title")}
            noDataTitle={t("category.demographics.chart.no.data.title")}
            noDataSubtitle={t("category.demographics.table.no.data")}
            automationId="industry-analysis-demographics-age-distribution-table"
        >
            {tableData ? (
                <DemographicsTable
                    tableRecords={tableData || []}
                    isLoading={false}
                    queryParams={pageFilters}
                />
            ) : null}
        </WidgetContainer>
    );
};
